<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'pageheader',
})
</script>
<template>
  <transition>
    <section class="auto-container flex align-center justify-start">
        <img  v-if="siteinfo" :src="addip(siteinfo.application_logo)" :alt="siteinfo.title" class="logo" />
        <ul class="nav flex1" :style="{transform:(menuopen?'scaleY(1)':'scaleY(0)')}">
          <li  class="nav-item" v-for="(item,i) in menu" :key="i">
            <div class="nav-title">
              <a :href="item.url">{{ item.text }}</a>
            </div>
            <div class="nav-line"></div>
            <ul class="nav-v" v-if="item.child.length>0">
                <li  class="nav-item" v-for="(it,u) in item.child" :key="u">
                    <div class="nav-title">
                      <a :href="item.url">{{ item.text }}</a>
                    </div>
                </li>
            </ul>
          </li>
        </ul>
        <template  v-if="device=='mobile'">
        <div class="flex1"></div>
        <MenuUnfoldOutlined :style="{transform:(menuopen?'rotate(90deg)':'rotate(0deg)')}" @click="toggleMenus"  class="openmenu" style="font-size: 2em;" />
        </template>
        <div  v-else-if="siteinfo" class="flex align-center">
          <PhoneOutlined />
          <span>{{ siteinfo.tel }}</span>
        </div>
    </section>
  </transition>
</template>
<script setup lang="ts" name="pageheader">
import { onMounted,ref,getCurrentInstance,nextTick,defineProps  } from 'vue';
import {AppstoreOutlined,MenuUnfoldOutlined,MobileOutlined,PhoneOutlined} from '@ant-design/icons-vue'
import {addip} from '@/utils/util'
import useSiteSettings from '@/store/useSiteSettings'
const {  device } = useSiteSettings()
const props= defineProps({
  siteinfo:Object
})
const menu=ref<Array>([])
const menuopen=ref<Boolean>(device.value=='mobile'?false:true)
onMounted(()=>{
  const app=getCurrentInstance()
  const api=app?.appContext.config.globalProperties.$api
  api.global.header().then(res=>{
    if(res.state==1){
      menu.value=res.data
    }
  })
})
const toggleMenus=():void=>{
  if(menuopen.value==false){
    menuopen.value=true
  }else{
    menuopen.value=false
  }
}
</script>

<style lang="less">
  @import '@/style/main.less';
  header{
    padding-inline:0;
      .auto-container{
        padding-top:0;padding-bottom:0;height:100%;
        .logo{height:50px;width:auto;max-width: 360px;}
        .anticon{font-size: 1.6em;padding:10px;}
        span{font-size: 1.4em;font-weight: bold}
        .nav{
           align-items: center;justify-content: center;margin:0;display:flex;
        .nav-title:hover{color:@primary}
        .nav-item{
          min-width:150px;position: relative;
          .nav-title{
          height:calc(@menu-height - 4px);display: flex;align-items: center;justify-content: center;cursor: pointer;font-size: 1.2em;
            &:hover a{color:@primary}
          }
          .nav-line{transition: all .2s linear;height:4px;background: transparent;transform: scaleX(0);transform-origin: 0% center;border-radius: 10px 10px 0 0 ;}
          &:hover{
            .nav-line{background: @primary;transform: scaleX(1);}
          }
        }
        .nav-item:hover .nav-v{transform: scaleY(1);}
        .nav-v{position: absolute;transform: scaleY(0);left:0;right:0;
          flex-direction:column;overflow:hidden;transition:all .2s linear; transform-origin:0% 0%;
            .nav-item{
                .nav-title{height:50px;padding:15px 10px;justify-content: flex-start; font-size:1em;border-bottom: none;cursor: pointer;
                }
                &:hover a{color:@primary}
            }
        }
      }
      .openmenu{font-size:2em;transition: all .2s linear;}
      }
}

</style>
